import React from 'react';
import InterviewSchedule from './InterviewSchedule';
import { Stack } from '@/Components/ui/layout';

export default function DashboardLayout() {
  return (
    <div className="flex flex-col gap-8 w-full">
      <InterviewSchedule />
    </div>
  );
}